import moment from "moment";

export const selectLoginModel = (state) => {
    return {
        userName: state.form["userName"],
        password: state.form["password"]
    };
};

export const selectChangePasswordModel = (state) => {
    return {
        UserName: state.form.changePasswordUserName,
        Password: state.form.changePasswordPassword,
        NewPassword: state.form.changePasswordNewPassword
    };
};

export const selectProductModel = (state, name) => {

    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        SKU: state.form[name + "SKU"],
        Name: state.form[name + "Name"],
        Type: state.form[name + "Type"],
        TypeId: state.form[name + "TypeId"] ? parseInt(state.form[name + "TypeId"]) : 0,
        CategoryId: state.form[name + "CategoryId"] ? parseInt(state.form[name + "CategoryId"]) : 0,
        PriceMatrixId: state.form[name + "PriceMatrixId"] ? parseInt(state.form[name + "PriceMatrixId"]) : 0,
        UnitPrice: state.form[name + "UnitPrice"] ? parseFloat(state.form[name + "UnitPrice"]) : 0,
        PromotionUnitPrice: state.form[name + "PromotionUnitPrice"] ? parseFloat(state.form[name + "PromotionUnitPrice"]) : 0,
        MemberUnitPrice: state.form[name + "MemberUnitPrice"] ? parseFloat(state.form[name + "MemberUnitPrice"]) : 0,
        EliteMemberUnitPrice: state.form[name + "EliteMemberUnitPrice"] ? parseFloat(state.form[name + "EliteMemberUnitPrice"]) : 0,
        IsElite: state.form[name + "IsElite"] ? true : false,
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        Image: state.form[name + "ImageURL"] ? state.form[name + "ImageURL"] : null,
        WeightPerUnit: state.form[`${name}WeightPerUnit`] ? parseFloat(state.form[`${name}WeightPerUnit`]) : null,
        BranchId: state.common.branchId,
        BaseCost: state.form[`${name}BaseCost`] ? parseFloat(state.form[`${name}BaseCost`]) : 0,
        LatestBaseCost: state.form[`${name}LatestBaseCost`] ? parseFloat(state.form[`${name}LatestBaseCost`]) : 0,
        Description: state.form[`${name}Description`],
        BarCode: state.form[`${name}BarCode`],
        CannabisSpecies: state.form[`${name}CannabisSpecies`],
        LegalBarCode: state.form[`${name}legalBarCode`],
        DepositEnabled: state.form[`${name}DepositEnabled`],
        DepositAmount: state.form[`${name}DepositAmount`],
        DFE: state.form[`${name}dfe`],
        WebMenuDisplayed: state.form[`${name}WebmenuDisplayEnabled`],
        Brand: state.form[`${name}Brand`],
        THC: state.form[`${name}THC`] ? parseFloat(state.form[`${name}THC`]) : null,
        CBD: state.form[`${name}CBD`] ? parseFloat(state.form[`${name}CBD`]) : null,
        THC_MIN: state.form[`${name}THCMin`] ? parseFloat(state.form[`${name}THCMin`]) : null,
        THC_MAX: state.form[`${name}THCMax`] ? parseFloat(state.form[`${name}THCMax`]) : null,
        CBD_MIN: state.form[`${name}CBDMin`] ? parseFloat(state.form[`${name}CBDMin`]) : null,
        CBD_MAX: state.form[`${name}CBDMax`] ? parseFloat(state.form[`${name}CBDMax`]) : null,
        UPC: state.form.ManualUPCNumber || "",
        WebName: state.form[name + "WebName"],
        Size: state.form[name + "Size"],
        SubCategoryName: state.form[name + "SubCategoryName"],
        jsonInfo: state.form[name + "jsonInfo"],

    };
};

export const selectProductCategoryModel = (state, compName) => {
    const copyState = { ...state.form };
    let idsTaxRates = [];
    for (let name in copyState) {
        if (copyState.hasOwnProperty(name) && name.indexOf(compName + "TaxRate-") !== -1) {
            if (copyState[name] === true) {
                let taxRateId = name.split(`${compName}TaxRate-`)[1];
                idsTaxRates.push(parseInt(taxRateId));
            }
        }
    }

    return {
        Id: state.form[compName + "Id"] ? parseInt(state.form[compName + "Id"]) : 0,
        Name: state.form[compName + "Name"],
        Status: state.form[compName + "Status"] ? "Active" : "Inactive",
        IsCannabis: state.form[compName + "IsCannabis"] ? true : false,
        IsRefundable: state.form[compName + "IsRefundable"] ? true : false,
        BranchId: state.common.branchId,
        IdsTaxRate: idsTaxRates,
        ClassOfCannabis: state.form[compName + "ClassOfCannabisText"],
        ClassOfCannabisId: state.form[compName + "ClassOfCannabis"] ? state.form[compName + "ClassOfCannabis"] : 0,
        BCCannabisClass: state.form[compName + "BCCannabisClass"] ? state.form[compName + "BCCannabisClass"] : 0,
        UnitOfMeasurement: state.form[compName + "UnitOfMeasurement"] ? state.form[compName + "UnitOfMeasurement"] : 1,
        PriceMargin: state.form[compName + "priceMargin"] ? state.form[compName + "priceMargin"] : null
    };
};

export const selectPOProductModel = (state, name) => {
    return {
        productId: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        product: state.form[name + "Name"],
        sku: state.form[name + "Sku"],
        type: state.form[name + "Type"],
        category: state.form[name + "Category"],
        quantity: state.form[name + "Quantity"] ? parseFloat(state.form[name + "Quantity"]) : 0,
        price: state.form[name + "TotalPrice"] ? parseFloat(state.form[name + "TotalPrice"]) : 0,
        unitPrice: state.form[name + "UnitPrice"] ? parseFloat(state.form[name + "UnitPrice"]) : 0,
        BranchId: state.common.branchId
    };
};

export const selectAuditProductModel = (state, name) => {
    return {
        id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        name: state.form[name + "Name"],
        sku: state.form[name + "Sku"],
        BranchId: state.common.branchId
    };
};
export const selectSafeManagementModel = (state, name) => {
    return {
        id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        amount: state.form[name + "Amount"] ? parseFloat(state.form[name + "Amount"]) : 0,
        type: state.form[name + "Type"] ? state.form[name + "Type"] : null,
        notes: state.form[name + "Notes"] ? state.form[name + "Notes"] : null,
        branchId: state.common.branchId
    };
};
export const selectBankDepositModel = (state, name) => {
    return {
        id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        depositDate: state.form[name + "DepositDate"] ? moment(state.form[name + "DepositDate"]).format("YYYY-MM-DD") : null,
        amount: state.form[name + "Amount"] ? parseFloat(state.form[name + "Amount"]) : 0,
        coinOrder: state.form[name + "CoinOrder"] ? parseFloat(state.form[name + "CoinOrder"]) : 0,
        tips: state.form[name + "Tips"] ? parseFloat(state.form[name + "Tips"]) : 0,
        notes: state.form[name + "Notes"] ? state.form[name + "Notes"] : null,
        referenceCode: state.form[name + "ReferenceCode"] ? state.form[name + "ReferenceCode"] : null,
        branchId: state.common.branchId,
        isHighTide: state.form[name + "IsHighTide"] ? state.form[name + "IsHighTide"] : false,
    };
};

export const selectVendorModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        Name: state.form[name + "Name"],
        LicenseNumber: state.form[name + "LicenseNumber"],
        CategoryId: state.form[name + "CategoryId"] ? parseInt(state.form[name + "CategoryId"]) : 0,
        Website: state.form[name + "Website"],
        Address: state.form[name + "Address"],
        Country: state.form[name + "Country"],
        State: state.form[name + "ProvinceState"],
        City: state.form[name + "City"],
        PostalCode: state.form[name + "PostalCode"],
        Phone: state.form[name + "Phone"],
        Email: state.form[name + "Email"],
        Contact: state.form[name + "Contact"],
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        BranchId: state.common.branchId
    };
};

export const selectPatientModel = (state, name) => {
    let contactMethods = [];
    if (state.form[name + "PreferredMethodEmail"]) {
        contactMethods.push("Email");
    }
    if (state.form[name + "PreferredMethodPhone"]) {
        contactMethods.push("Phone");
    }
    if (state.form[name + "PreferredMethodSms"]) {
        contactMethods.push("SMS");
    }
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        Phone: state.form[name + "Phone"],
        Email: state.form[name + "Email"] ? state.form[name + "Email"] : null,
        AdditionalInformation: state.form[name + "AdditionalInformation"],
        ContactMethodsTypes: contactMethods,
        MemberSince: state.form[name + "MemberSince"] ? new Date(state.form[name + "MemberSince"]) : null,
        //ExpirationDate: state.form[name + "Expiration"] ? new Date(state.form[name + "Expiration"]) : null,
        DateOfBirth: state.form[name + "Birthdate"] ? new Date(state.form[name + "Birthdate"]) : null,
        Gender: state.form[name + "Gender"],
        IdentificationType: state.form[name + "IdentificationType"],
        IdentificationNumber: state.form[name + "IdentificationNumber"],
        FirstName: state.form[name + "FirstName"],
        LastName: state.form[name + "LastName"],
        CareGiver: state.form[name + "CareGiver"],
        PreferredName: state.form[name + "PreferredName"],
        CardNumber: state.form[name + "CardNumber"] ? state.form[name + "CardNumber"] : "",
        Address: state.form[name + "Address"],
        Country: state.form[name + "Country"],
        State: state.form[name + "ProvinceState"],
        City: state.form[name + "City"],
        PostalCode: state.form[name + "PostalCode"],
        Password: state.form[name + "PatientPassword"],
        IsMember: state.form[name + "IsMember"],
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        Photo: state.form[name + "Photo"] ? state.form[name + "Photo"] : null,
        DownloadPhotoUrl: state.form[name + "DownloadPhotoUrl"],
        //MedicalInformations: state.form[name + "MedicalInformations"]
        BranchId: state.common.branchId,
        rewardPoint: state.form[name + "RewardPoint"],
        AlpineIQNotifications: state.form[name + "AlpineIQLegal"] ? state.form[name + "AlpineIQLegal"] : false,
        onlineUserSignedUp: state.form[name + "OnlineUserSignedUp"] ? state.form[name + "OnlineUserSignedUp"] : false,
        onlineUserLockedOut: state.form[name + "OnlineUserLockedOut"] ? state.form[name + "OnlineUserLockedOut"] : false,
        sbOptInSpringBig: state.form[name + "sbOptInSpringBig"] ? state.form[name + "sbOptInSpringBig"] : false,
        sbOptInTechPos: state.form[name + "sbOptInTechPos"] ? state.form[name + "sbOptInTechPos"] : false,
        sbPatientExists: state.form[name + "sbPatientExists"] ? state.form[name + "sbPatientExists"] : false
    };
};

export const selectDoctorModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        FirstName: state.form[name + "FirstName"],
        LastName: state.form[name + "LastName"],
        License: state.form[name + "License"],
        Clinic: state.form[name + "Clinic"],
        Phone: state.form[name + "Phone"],
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        Address: state.form[name + "Address"],
        Zip: state.form[name + "PostalCode"],
        Country: state.form[name + "Country"],
        State: state.form[name + "ProvinceState"],
        City: state.form[name + "City"],
        BranchId: state.common.branchId
    };
};

export const selectPurchaseOrderModel = (state, name) => {
    const taxes = Object.keys(state.form)
        .filter(k => k.includes(`${name}TAX`))
        .map(k => {
            return {
                id: parseInt(k.split("-")[1]),
                amount: parseFloat(state.form[k])
            }
        });

    const products = state.entity.productListPO.map((product) => {
        return {
            Id: product.id,
            ProductId: product.productId,
            Quantity: product.quantity,
            UnitPrice: product.unitPrice,
            Price: product.price,
            BranchId: state.common.branchId
        };
    });

    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        Description: state.form[name + "Name"],
        VendorID: state.form[name + "VendorID"],
        Status: state.form[name + "Status"],
        PaymentDueDate: state.form[name + "PaymentDueDate"] ? new Date(state.form[name + "PaymentDueDate"]) : null,
        DateExpected: state.form[name + "DateExpected"] ? new Date(state.form[name + "DateExpected"]) : null,
        Products: products,
        BranchId: state.common.branchId,
        Total: state.form[name + "POTotal"],
        SubTotal: state.form[name + "POSubtotal"],
        DeliveryFee: state.form[name + "DeliveryFee"],
        RecycleFee: state.form[name + "RecycleFee"],
        TotalDepositAmount: state.form[name + "TotalDepositAmount"],
        GST: state.form[name + "GST"] || 0,
        HST: state.form[name + "HST"] || 0,
        PST: state.form[name + "PST"] || 0,
        QST: state.form[name + "QST"] || 0,
        Taxes: taxes,
        SupplierInvoiceNumber: state.form[name + "SupplierInvoiceNumber"] || "",
        Credits: state.form[name + "Credits"]
    };
};

export const selectWeightSettingModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        Name: state.form[name + "Name"],
        Weight: state.form[name + "Measurement"] ? parseFloat(state.form[name + "Measurement"]) : 0,
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        BranchId: state.common.branchId
    };
};

export const selectPriceMatrixModel = (state, compName) => {
    const copyState = { ...state.form };
    let details = [];
    // get data for details
    for (let name in copyState) {
        if (copyState.hasOwnProperty(name) && name.indexOf(compName + "Details") !== -1) {
            if (name.indexOf(`${compName}DetailsPrice`) !== -1) {
                let weightId = name.split(`${compName}DetailsPrice`)[1];
                details.push({
                    WeightSettingId: parseInt(weightId),
                    Price: state.form[name] ? parseFloat(state.form[name]) : 0.00,
                    MemberPrice: state.form[`${compName}DetailsMemberPrice${weightId}`] ? parseFloat(state.form[`${compName}DetailsMemberPrice${weightId}`]) : 0.00,
                    IsCampaign: state.form[`${compName}DetailsIsCampaign_${weightId}`],
                    BranchId: state.common.branchId
                });
            }
        }
    }

    return {
        Id: state.form[compName + "Id"] ? parseInt(state.form[compName + "Id"]) : 0,
        Name: state.form[compName + "Name"],
        Status: state.form[compName + "Status"] ? "Active" : "Inactive",
        PriceMatrixDetails: details,
        BranchId: state.common.branchId
    };
};

export const selectEmployeeModel = (state, name) => {
    const copyState = { ...state.form };
    let branches = [];
    // get data for details
    for (let item in copyState) {
        if (copyState.hasOwnProperty(item) && item.indexOf(name + "Branch-") !== -1) {
            if (copyState[item] === true) {
                let branchId = parseInt(item.split(`${name}Branch-`)[1]);
                branches.push(branchId);
            }
        }
    }

    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        Role: state.form[name + "Role"],
        FirstName: state.form[name + "FirstName"],
        LastName: state.form[name + "LastName"],
        DateOfBirth: state.form[name + "Birthdate"] ? new Date(state.form[name + "Birthdate"]) : null,
        Phone: state.form[name + "Phone"],
        Email: state.form[name + "Email"],
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        Address: state.form[name + "Address"],
        PostalCode: state.form[name + "PostalCode"],
        Country: state.form[name + "Country"],
        State: state.form[name + "ProvinceState"],
        City: state.form[name + "City"],
        UserName: state.form[name + "Email"],
        Password: state.form[name + "Password"],
        PinPassword: state.form[name + "Pin"] ? state.form[name + "Pin"] : '',
        SIN: state.form[name + "SIN"] || '',
        HourlyRate: state.form[name + "HourlyRate"] || 0,
        HiredDate: state.form[name + "HiredDate"] ? new Date(state.form[name + "HiredDate"]) : null,
        BranchId: state.common.branchId,
        Branches: branches,
        AccountLockedOut: state.form[name + "AccountLockedOut"] || false
    };
};

export const selectPOSPatientSearchModel = (state, name) => {
    return {
        cardNumber: state.form[`${name}CardNumber`] ? state.form[`${name}CardNumber`] : null,
        firstName: state.form[`${name}FirstName`] ? state.form[`${name}FirstName`] : null,
        lastName: state.form[`${name}LastName`] ? state.form[`${name}LastName`] : null,
        preferredName: state.form[`${name}PreferredName`] ? state.form[`${name}PreferredName`] : null,
        phone: state.form[`${name}Phone`] ? state.form[`${name}Phone`] : null,
        email: state.form[`${name}Email`] ? state.form[`${name}Email`] : null,
        memberNumber: state.form[`${name}MemberNumber`] ? state.form[`${name}MemberNumber`] : null,
        isNotMember: state.form[`${name}IsNotMember`] ? state.form[`${name}IsNotMember`] : null,
        BranchId: state.common.branchId
    };
};


export const selectDeviceModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        DeviceTypeId: state.form[name + "DeviceType"] ? parseInt(state.form[name + "DeviceType"]) : 0,
        DeviceRoleId: state.form[name + "DeviceRole"] ? parseInt(state.form[name + "DeviceRole"]) : 0,
        DeviceWorkStationId: state.form[name + "DeviceWorkStation"] ? parseInt(state.form[name + "DeviceWorkStation"]) : 0,
        IPAddress: state.form[name + "IPAddress"],
        PINPadId: state.form[name + "PINPadId"],
        PINPadIntegrated: state.form[name + "PINPadIntegrated"],
        Status: state.form[name + "Status"] ? "Online" : "Offline",
        BranchId: state.common.branchId
    };
};

export const selectPaymentModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        Name: state.form[name + "Name"],
        Value: state.form[name + "Value"],
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        BranchId: state.common.branchId
    };
};

export const selectTaxRateModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        Name: state.form[name + "Name"],
        Rate: state.form[name + "Rate"] ? parseFloat(state.form[name + "Rate"]) : 0,
        Value: state.form[name + "Value"],
        Status: state.form[name + "Status"] ? "Active" : "Inactive",
        BranchId: state.common.branchId,
        ExcludeBranches: state.form[name + "ExcludeBranches"] ? true : false,
        BranchIdsToExclude: Array.isArray(state.form[name + "BranchIdsToExclude"])
            ? state.form[name + "BranchIdsToExclude"].join(",")
            : ""
    };
};

export const selectPOSCancellationCredentials = (state) => {
    return {
        UserName: state.form['POSOrderCancellationUserName'],
        Password: state.form['POSOrderCancellationPassword'],
        BranchId: state.common.branchId,
        EmployeeId: state.entity.pin.employee.id,
        CashFlowId: state.entity.cashFlow ? state.entity.cashFlow.id : 0,
        NeedApproval: state.common.applicationSettings.cancelOrderNeedApproval,
        PinCode: state.form[`POSOrderCancellationPinCode`] || ''
    };
};

export const selectOpenOrdersCancellation = (state) => {
    return {
        BranchId: state.common.branchId,
        EmployeeId: state.entity.pin.employee.id,
        CashFlowId: state.entity.cashFlow ? state.entity.cashFlow.id : 0,
        OrderIds: state.entity.oldOpenOrders && state.entity.oldOpenOrders.length > 0 ? state.entity.oldOpenOrders : []
    }
};

export const selectOpenOnlineOrdersCancellation = (state) => {
    return {
        OrderIds: state.entity.oldOpenOnlineOrders && state.entity.oldOpenOnlineOrders.length > 0 ? state.entity.oldOpenOnlineOrders : []
    }
}

export const selectRegisterMovementModel = (state, name) => {
    return {
        // Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        // Balance: state.form[name + "Balance"],
        CashInDate: state.form[name + "CashInDate"],
        CashInAmount: state.form[name + "CashInAmount"],
        CashOutDate: state.form[name + "CashOutDate"],
        CashOutAmount: state.form[name + "CashOutAmount"],
        BranchId: state.common.branchId
    };
};

export const selectDeviceRoleModel = (state, name) => {
    return {
        Name: state.form[name + "Name"],
        //Description: state.form[name + "Description"],
        Status: true,
        BranchId: state.common.branchId
    };
};

export const selectDeviceWorkStationModel = (state, name) => {
    return {
        Name: state.form[name + "Name"],
        //Description: state.form[name + "Description"],
        Status: true,
        BranchId: state.common.branchId
    };
};

export const selectPOSDiscountModel = (state, name) => {
    return {
        OrderId: state.entity.posOrder ? state.entity.posOrder.id : 0,
        UserName: state.form[`${name}Username`],
        Password: state.form[`${name}Password`],
        Notes: state.form[`${name}Notes`],
        Percentage: state.form[`${name}IsPercentage`] === true ? state.form[`${name}Percentage`] ? parseInt(state.form[`${name}Percentage`]) : 0 : 0,
        Amount: !state.form[`${name}IsPercentage`] ? state.form[`${name}Amount`] ? parseFloat(state.form[`${name}Amount`]) : 0 : 0,
        BranchId: state.common.branchId,
        EmployeeId: state.entity.pin.employee.id,
        IsFromRewardPoints: state.form[`${name}DiscountType`] == 3 ? true : false,
        CustomizedDiscountId: state.form[`${name}CustomizedDiscountSelection`] || 0,
        PinCode: state.form[`${name}PinCode`] || '',
        ModifiedDate: state.entity.posOrder ? state.entity.posOrder.modifiedDate : ""
    };
};


export const selectDiscountProducts = (state, compName, products = [], priceMatchRows = []) => {
    const copyState = { ...state };
    let data = [];
    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.includes(`${compName}Type-`) ||
                name.includes(`${compName}OrderProductNotes-`) ||
                name.includes(`${compName}Amount-`) ||
                name.includes(`${compName}Percentage-`) ||
                name.includes(`${compName}PriceMatch-`) ||
                name.includes(`${compName}AlpineIQRedeemURL-`) ||
                name.includes(`${compName}AlpineIQRewardPoints-`)) {

                const productId = parseInt(name.split('-')[1]);
                let productData = data.find(item => item.productId === productId);

                if (!productData) {
                    productData = { productId };
                    data.push(productData);
                }

                // Assign properties based on the name
                if (name.includes(`${compName}Type-`)) {
                    productData.type = copyState[name];
                } else if (name.includes(`${compName}Amount-`)) {
                    productData.amount = copyState[name];
                } else if (name.includes(`${compName}Percentage-`)) {
                    productData.percentage = copyState[name];
                } else if (name.includes(`${compName}AlpineIQRedeemURL-`)) {
                    productData.alpineIQRedeemURL = copyState[name];
                } else if (name.includes(`${compName}AlpineIQRewardPoints-`)) {
                    productData.pointsDeduction = copyState[name];
                } else if (name.includes(`${compName}OrderProductNotes-`)) {
                    productData.orderProductNotes = copyState[name];
                }

                products.filter(product => product.status === 1).map((product) => {
                    if (product.priceMatchPlusPercentage == 0 || product.priceMatchPlusPercentage == null) {
                        productData.ApplyPriceMatchPlusPercentage = priceMatchRows.length > 0
                            ? priceMatchRows.some(row => row.id === productId)
                            : false;
                    }
                });
            }
        }
    }

    return data;
};

export const selectPOSRemoveDiscountModel = (state, compName, stackDiscountsEnabled) => {
    const formState = state.form;
    const getIdFromName = (name, prefix) => {
        if (name.includes(prefix) && formState[name] === true) {
            let namesplit = name.split(prefix)[1];
            if (namesplit.includes(",")){
                namesplit = namesplit.split(",")
                return namesplit.map(id => parseInt(id, 10))
            } else {
                return parseInt(namesplit, 10)
            } 
        }
        return null;
    };

    const orderData = Object.keys(formState)
        .map(name => getIdFromName(name, `${compName}RemoveDiscount-`))
        .filter(id => id !== null);
    
    const priceByQuantityData = Object.keys(formState)
      .map(name => getIdFromName(name, `${compName}RemovePriceByQuantityDiscount-`))
      .filter(id => id !== null)
      .reduce((acc, current) => {return acc.concat(current)}, []);

    if (stackDiscountsEnabled) {
        const productData = Object.keys(formState)
            .map(name => getIdFromName(name, `${compName}RemoveProductDiscount-`))
            .filter(id => id !== null);
        return { orderData, productData: productData.concat(priceByQuantityData) };
    } else {
        return orderData.concat(priceByQuantityData);
    }
};

export const selectInventoryAuditModel = (state, compName) => {
    return {
        Id: state.form[compName + "Id"] ? parseInt(state.form[compName + "Id"]) : 0,
        Name: state.form[compName + "TitleName"],
        InventoryAuditProducts: [],
        BranchId: state.common.branchId,
        LockExpectedQuantity: state.form[compName + "LockExpectedQuantity"] || false
    }
};

export const selectComboModel = (state, compName) => {
    const copyState = { ...state.form };
    let weekdays = [];

    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}WeekDay-`) !== -1) {
                if (copyState[name] === true) {
                    let day = name.split(`${compName}WeekDay-`)[1];
                    weekdays.push(day);
                }
            }
        }
    }

    let startTime = null;
    let endTime = null;

    if (state.form[compName + "StartTime"]) {
        startTime = new Date(state.form[`${compName}StartTime`]).toLocaleString('en-US');
    }
    if (state.form[compName + "EndTime"]) {
        endTime = new Date(state.form[`${compName}EndTime`]).toLocaleString('en-US');
    }

    return {
        Id: state.form[compName + "Id"] ? parseInt(state.form[compName + "Id"]) : 0,
        Name: state.form[compName + "Name"],
        Price: state.form[compName + "Price"],
        Status: state.form[compName + "Status"] ? 1 : 2,
        Products: [],
        BranchId: state.common.branchId,
        DateFrom: state.form[compName + "StartDate"] || null,
        DateTo: state.form[compName + "EndDate"] || null,
        DaysOfWeek: weekdays,
        StartTime: startTime,
        EndTime: endTime
    }
}

export const selectDiscountModel = (state, compName) => {
    return {
        Id: state.form[compName + "Id"] ? parseInt(state.form[compName + "Id"]) : 0,
        Name: state.form[compName + "Name"] || '',
        Value: state.form[compName + "Value"] || 0,
        CustomizedDiscountType: state.form[compName + "CustomizedDiscountType"] ? 1 : 2,
        Status: state.form[compName + "Status"] ? 1 : 2,
        BranchId: state.common.branchId,
        PromotionCode: state.form[compName + "PromotionCode"],
        MinimumAmountToApplyPromotionCode: state.form[compName + "MinimumAmountToApplyPromotionCode"],
        StickyCardsDiscount: state.form[compName + "StickyCardsDiscount"] || false,
        StickyCardPointsNeededToApply: state.form[compName + "StickyCardPointsNeededToApply"] || 0
    }
}

export const selectCampaignModel = (state, compName) => {
    const copyState = { ...state.form };
    let weekdays = [];

    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}WeekDay-`) !== -1) {
                if (copyState[name] === true) {
                    let day = name.split(`${compName}WeekDay-`)[1];
                    weekdays.push(day);
                }
            }
        }
    }

    return {
        Id: state.form[compName + "Id"] ? parseInt(state.form[compName + "Id"]) : 0,
        Name: state.form[compName + "Name"],
        Type: state.form[compName + "Type"] ? parseInt(state.form[compName + "Type"]) : 0,
        DateFrom: state.form[compName + "StartDate"] || null,
        DateTo: state.form[compName + "EndDate"] || null,
        DaysOfWeek: weekdays,
        DiscountType: state.form[compName + "ApplyPriceByQuantity"] ? 3 : (state.form[compName + "DiscountType"] ? parseInt(state.form[compName + "DiscountType"]) : 0),
        DiscountValue: state.form[compName + "ApplyPriceByQuantity"] ? 0 : (state.form[compName + "DiscountValue"] ? parseFloat(state.form[compName + "DiscountValue"]) : 0),
        Description: state.form[compName + "Description"],
        Status: state.form[compName + "Status"] ? "Active" : "Inactive",
        ProductsCategoriesIds: [],
        ProductsIds: [],
        ProductsPriceByQuantity: [],
        currentBranchId: state.common.branchId,
        branchIds: state.form[compName + "BranchOption"] ? state.form[compName + "BranchOption"].join(",") : state.common.branchId,
        ApplyForMembersOnly: state.form[compName + "ApplyForMember"],
        ApplyForNonMembersOnly: state.form[compName + "ApplyForNonMember"],
        ApplyOnlineOnly: state.form[compName + "ApplyOnline"],
        ApplyInStoreOnly: state.form[compName + "ApplyInStore"],
        StartTime: state.form[`${compName}StartTime`],
        EndTime: state.form[`${compName}EndTime`],
        ApplyPriceByQuantity: state.form[compName + "ApplyPriceByQuantity"],
        AllowMixAndMatch: state.form[compName + "AllowMixAndMatch"],
        IncrementalDiscount: state.form[compName + "IncrementalDiscount"]
    };
};

export const selectCampaignSelectedCategories = (formState, compName) => {
    const copyState = { ...formState };
    let data = [];

    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}ProductCategory-`) !== -1) {
                if (copyState[name] === true) {
                    let id = name.split(`${compName}ProductCategory-`)[1];
                    data.push(parseInt(id));
                }
            }
        }
    }

    return data;
};

export const selectedCampaigns = (formState, compName) => {
    const copyState = { ...formState };
    let data = [];

    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}ProductCampaign-`) !== -1) {
                if (copyState[name] === true) {
                    let id = name.split(`${compName}ProductCampaign-`)[1];
                    data.push(parseInt(id));
                }
            }
        }
    }

    return data;
};

export const selectProductCategorySearchSelectedCategories = (formState, compName) => {
    const copyState = { ...formState };
    let data = [];

    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}ProductCategory-`) !== -1) {
                if (copyState[name] === true) {
                    let id = name.split(`${compName}ProductCategory-`)[1];
                    data.push(parseInt(id));
                }
            }
        }
    }

    return data;
};

export const selectRefundProducts = (state, compName) => {
    const copyState = { ...state.form };
    let data = [];
    //const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));

    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}Quantity_`) !== -1 || name.indexOf(`${compName}RefundReason_`) !== -1 || name.indexOf(`${compName}DefectiveReason_`) !== -1 || name.indexOf(`${compName}DestroyMethod_`) !== -1 || name.indexOf(`${compName}DestroyReason_`) !== -1) {
                const productId = parseInt(name.split('_')[1]);
                let productData = data.filter(item => item.OrderProductId === productId)[0];
                if (!productData) {
                    productData = { OrderProductId: productId };
                    data.push(productData);
                }
                if (name.indexOf(`${compName}Quantity_`) !== -1) {
                    productData.Quantity = copyState[name] ? parseFloat(copyState[name]) : 0;
                }
                else if (name.indexOf(`${compName}RefundReason_`) !== -1) {
                    productData.RefundReason = copyState[name] ? parseInt(copyState[name]) : 0;
                }
                else if (name.indexOf(`${compName}DefectiveReason_`) !== -1) {
                    productData.DefectiveReason = copyState[name] ? (copyState[name]) : 0;
                }
                else if (name.indexOf(`${compName}DestroyMethod_`) !== -1) {
                    productData.DestroyMethod = copyState[name] ? (copyState[name]) : 0;
                }
                else if (name.indexOf(`${compName}DestroyReason_`) !== -1) {
                    productData.DestroyReason = copyState[name] ? (copyState[name]) : 0;
                }
            }
        }
    }
    return {
        UserName: state.form[`${compName}Username`],
        Password: state.form[`${compName}Password`],
        BranchId: state.common.branchId ? parseFloat(state.common.branchId) : 0,
        EmployeeId: state.entity.pin.employee.id,
        OrderProductsVM: data.filter(item => item.Quantity && item.Quantity !== 0 && item.RefundReason && item.RefundReason !== 0),
        ReturnMethod: state.form[`${compName}RefundMethod`],
        CashFlowId: state.entity.cashFlow ? state.entity.cashFlow.id : 0,
        PinCode: state.form[`${compName}PinCode`] || '',
        CardType: state.form["POSPaymentsCardType"] || 0,
        Notes: state.form[`${compName}Notes`] || '',
        RefundShipping: state.form[`${compName}RefundShipping`] || false
    };
};

export const giftCardPaymentModel = (state, compName) => {
    return {
        BranchId: state.common.branchId,
        TotalAmount: state.form[`${compName}Amount`],
        Pan: state.form[`${compName}GiftCardNumber`],
        Expdate: state.form[`${compName}GiftCardExpireDate`],
        CvdValue: state.form[`${compName}GiftCardCvdValue`],
        TerminalId: state.entity.cashFlow ? state.entity.cashFlow.terminalId : '',
        ProcessMethod: state.form[`${compName}processMethod`] === true ? 1 : 0
    }
}

export const selectRemoveRefundProducts = (state, compName) => {
    const copyState = { ...state.form };
    let data = [];
    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}RemoveRefund-`) !== -1) {
                const orderProductId = parseInt(name.split('-')[1]);
                if (copyState[name] === true)
                    data.push(orderProductId);
            }
        }
    }
    return data;
};

export const selectEmployeeShiftModel = (state, compName) => {
    const copyState = { ...state };

    let shifts = [];
    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            let data = null;
            if (name.indexOf(`${compName}-ClockIn-`) !== -1) {
                const id = parseInt(name.split(`${compName}-ClockIn-`)[1]);
                data = shifts.filter(item => item.id === id)[0];
                let date = new Date(copyState[name]);
                date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
                if (!data) {
                    data = {
                        id: id,
                        punchInDate: date
                    };
                    shifts.push(data);
                }
                data.punchInDate = date;
            }
            if (name.indexOf(`${compName}-ClockOut-`) !== -1) {
                const id = parseInt(name.split(`${compName}-ClockOut-`)[1]);
                data = shifts.filter(item => item.id === id)[0];
                let date = new Date(copyState[name]);
                date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
                if (!data) {
                    data = {
                        id: id,
                        punchOutDate: copyState[name] ? date : null
                    };
                    shifts.push(data);
                }
                data.punchOutDate = copyState[name] ? date : null;
            }
            if (name.indexOf(`${compName}-PaidBreak-`) !== -1) {
                const id = parseInt(name.split(`${compName}-PaidBreak-`)[1]);
                data = shifts.filter(item => item.id === id)[0];
                if (!data) {
                    data = {
                        id: id,
                        paidBreak: copyState[name] === true ? true : false
                    };
                    shifts.push(data);
                }
                data.paidBreak = copyState[name] === true ? true : false;
            }
            if (name.indexOf(`${compName}-Notes-`) !== -1) {
                const id = parseInt(name.split(`${compName}-Notes-`)[1]);
                data = shifts.filter(item => item.id === id)[0];
                if (!data) {
                    data = {
                        id: id,
                        notes: copyState[name]
                    };
                    shifts.push(data);
                }
                data.notes = copyState[name];
            }
            if (name.indexOf(`${compName}-Approve-`) !== -1) {
                const id = parseInt(name.split(`${compName}-Approve-`)[1]);
                data = shifts.filter(item => item.id === id)[0];
                if (!data) {
                    data = {
                        id: id,
                        approve: copyState[name] === true ? true : false
                    };
                    shifts.push(data);
                }
                data.approve = copyState[name] === true ? true : false;
            }
        }
    }

    return shifts;
};

export const selectShiftModel = (state, compName) => {
    let punchInDate = new Date(state.form[`${compName}ClockIn`]);
    punchInDate.setHours(punchInDate.getHours() - punchInDate.getTimezoneOffset() / 60);
    let punchOutDate = null;
    if (state.form[`${compName}ClockOut`]) {
        punchOutDate = new Date(state.form[`${compName}ClockOut`]);
        punchOutDate.setHours(punchOutDate.getHours() - punchOutDate.getTimezoneOffset() / 60);
    }
    return {
        EmployeeId: state.form[`${compName}EmployeeId`] ? parseInt(state.form[`${compName}EmployeeId`]) : 0,
        Date: state.form[`${compName}Date`] ? new Date(state.form[`${compName}Date`]) : null,
        PunchInDate: state.form[`${compName}ClockIn`] ? punchInDate : null,
        PunchOutDate: punchOutDate,
        BranchId: state.common.branchId
    };
};

export const selectSettingsModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        TokenName: state.form[name + "tokenName"],
        DeviceKeyName: state.form[name + "deviceKeyName"],
        AgeValidation: state.form[name + "ageValidation"] ? parseInt(state.form[name + "ageValidation"]) : 0,
        MemberDiscountPercentage: state.form[name + "memberDiscountPercentage"] ? parseFloat(state.form[name + "memberDiscountPercentage"]) : 0,
        SalesPersonDiscountThreshold: state.form[name + "salesPersonDiscountThreshold"] ? parseFloat(state.form[name + "salesPersonDiscountThreshold"]) : 0,
        CashInAmountByDefault: state.form[name + "cashInAmountByDefault"] ? parseFloat(state.form[name + "cashInAmountByDefault"]) : 0,
        CashDropAmount: state.form[name + "cashDropAmount"] ? parseFloat(state.form[name + "cashDropAmount"]) : 0,
        SuggestedCashDropAmount: state.form[name + "suggestedCashDropAmount"] ? parseFloat(state.form[name + "suggestedCashDropAmount"]) : 0,
        CashDropAmountToKeep: state.form[name + "cashDropAmountToKeep"] ? parseFloat(state.form[name + "cashDropAmountToKeep"]) : 0,
        PreRollCategoryId: state.form[name + "preRollCategoryId"] ? parseInt(state.form[name + "preRollCategoryId"]) : 0,
        ToleranceCashOutAmount: state.form[name + "toleranceCashOutAmount"] ? parseFloat(state.form[name + "toleranceCashOutAmount"]) : 0,
        DoNotShowUnitProductQuantityOver: state.form[name + "doNotShowUnitProductQuantityOver"] ? parseFloat(state.form[name + "doNotShowUnitProductQuantityOver"]) : 0,
        DoNotShowWeightProductQuantityOver: state.form[name + "doNotShowWeightProductQuantityOver"] ? parseFloat(state.form[name + "doNotShowWeightProductQuantityOver"]) : 0,
        StoreOpenHour: state.form[name + "storeOpenHour"] ? parseInt(state.form[name + "storeOpenHour"]) : 0,
        StoreCloseHour: state.form[name + "storeCloseHour"] ? parseInt(state.form[name + "storeCloseHour"]) : 0,
        NoSalesAllowedAfterStoreHours: state.form[name + "NoSalesAllowedAfterStoreHours"],
        Name: state.form[name + "name"],
        Phone: state.form[name + "phone"],
        WebSite: state.form[name + "site"],
        Address: state.form[name + "street"],
        City: state.form[name + "city"],
        ProvinceState: state.form[name + "provinceState"],
        Country: state.form[name + "country"],
        PostalCode: state.form[name + "postalCode"],
        BranchId: state.common.branchId ? parseFloat(state.common.branchId) : 0,
        EnablePinPassword: state.form[name + "EnablePinPassword"],
        Email: state.form[name + "email"],
        GSTNumber: state.form[name + "gstNumber"],
        NumberOfCopies: state.form[name + "numberOfCopies"],
        PosReceiptBottomText: state.form[name + "posReceiptBottomText"],
        showOpenOnlineOrders: state.form[name + "showOpenOnlineOrders"],
        ReceivePurchaseOrderWhenCreate: state.form[name + "ReceivePurchaseOrderWhenCreate"],
        showOpenOrders: state.form[name + "showOpenOrders"],
        crsaNumber: state.form[name + "crsaNumber"],
        primaryContactFullName: state.form[name + "primaryContactFullName"],
        primaryContactEmail: state.form[name + "primaryContactEmail"],
        secondaryContactFullName: state.form[name + "secondaryContactFullName"],
        secondaryContactEmail: state.form[name + "secondaryContactEmail"],
        managementEmployeeCount: state.form[name + "managementEmployeeCount"],
        administrativeEmployeeCount: state.form[name + "administrativeEmployeeCount"],
        salesEmployeeCount: state.form[name + "salesEmployeeCount"],
        productionEmployeeCount: state.form[name + "productionEmployeeCount"],
        otherEmployeeCount: state.form[name + "otherEmployeeCount"],
        DiscountNeedManagerApproval: state.form[name + "DiscountNeedManagerApproval"],
        ReceiptShowEmployeeFirstName: state.form[name + "receiptShowEmployeeFirstName"],
        ReceiptShowEmployeeLastName: state.form[name + "receiptShowEmployeeLastName"],
        ReceiptShowGSTNumber: state.form[name + "receiptShowGSTNumber"],
        ReceiptShowMemberSavings: state.form[name + "receiptShowMemberSavings"],
        ReceiptShowOrderNumber: state.form[name + "receiptShowOrderNumber"],
        ReceiptShowProductCount: state.form[name + "receiptShowProductCount"],
        ReceiptShowTerminal: state.form[name + "receiptShowTerminal"],
        ReceiptShowMemberName: state.form[name + "receiptShowMemberName"],
        ReceiptShowVisitCount: state.form[name + "receiptShowVisitCount"],
        ReceiptShowMemberPoints: state.form[name + "receiptShowMemberPoints"],
        ReceiptShowCreatedDate: state.form[name + "receiptShowCreatedDate"],
        InternalMessage: state.form[name + "internalMessage"],
        BannerImageUrl: state.form[name + "bannerImageURL"],
        OCSHashKey: state.form[name + "OCSHashKey"],
        StackDiscountsEnabled: state.form.SettingsPageStackDiscountEnable,
        GenericGiftCardEnabled: state.form.SettingsPageGenericGiftCardEnabled,
        hideSearchBar: state.form[name + "HideSearchBar"],
        taxExemptAllEnabled: state.form[name + "TaxExemptAllEnabled"],
        refundNeedManagerApproval: state.form[name + "RefundNeedManagerApproval"],
        storeCreditExpirationDays: state.form[name + "StoreCreditExpirationDays"],
        showPOSBulkImport: state.form[name + "showPOSBulkImport"],
        showAddMemberAfterSale: state.form[name + "ShowAddMemberAfterSale"],
        logoutPinAfterSeconds: state.form[name + "LogoutPinAfterSeconds"],
        offlineProductScan: state.form[name + "OfflineProductScan"],
        cachingProducts: state.form[name + "CachingProducts"]
    };
};

export const selectMixAndMatchModel = (state, compName) => {
    const formState = state.form;
    return {
        Id: formState[`${compName}Id`] ? parseInt(formState[`${compName}Id`]) : 0,
        Name: formState[`${compName}Name`],
        Description: formState[`${compName}Description`],
        Status: formState[`${compName}Status`] ? "Active" : "Inactive",
        DateFrom: formState[`${compName}StartDate`] ? new Date(formState[`${compName}StartDate`]) : null,
        DateTo: formState[`${compName}EndDate`] ? new Date(formState[`${compName}EndDate`]) : null,
        BranchId: state.common.branchId
    };
};

export const selectMixAndMatchSettingModel = (state, compName) => {
    const formState = state.form;
    return {
        quantity: formState[`${compName}Quantity`] ? parseFloat(formState[`${compName}Quantity`]) : 0,
        type: formState[`${compName}Type`] ? parseInt(formState[`${compName}Type`]) : 0,
        amount: formState[`${compName}Amount`] ? parseFloat(formState[`${compName}Amount`]) : 0
    };
};

export const selectMixAndMatchPriceSettingsIds = (state, compName) => {
    const copyState = { ...state.form };
    let data = [];

    for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
            if (name.indexOf(`${compName}PriceMatrix-`) !== -1) {
                if (copyState[name] === true) {
                    let id = name.split(`${compName}PriceMatrix-`)[1];
                    data.push(parseInt(id));
                }
            }
        }
    }

    return data;
};

export const selectMenuForm2 = (state, compName) => {
    return {
        Id: 1,
        Name: state.form[compName + "Name"],
        Description: state.form[compName + "Description"],
        Status: state.form[compName + "Status"] == undefined ? false : state.form[compName + "Status"],
        ProductCategoryIds: [],
        ProductIds: [],
        ProductCampaignIds: [],
        IsMenu: state.form[compName + "IsMenu"]
    }
}
export const selectMenuForm = (state, componentName) => {
    return {
        Name: state.form[`${componentName}NameText`] ? state.form[`${componentName}NameText`] : (state.form[`${componentName}Name`] || ''),
        Description: state.form[`${componentName}Description`] || '',
        Status: state.form[`${componentName}Status`] && state.form[`${componentName}Status`] === true ? "Active" : "Inactive",
        IsMenu: state.form[`${componentName}IsMenu`] && state.form[`${componentName}IsMenu`] === true ? true : false
    };
};

export const selectCarouselForm = (state, componentName) => {
    return {
        Name: state.form[`${componentName}Name`] || '',
        Description: state.form[`${componentName}Description`] || '',
        Status: state.form[`${componentName}Status`] && state.form[`${componentName}Status`] === true ? "Active" : "Inactive",
        IsMenu: state.form[`${componentName}IsMenu`] && state.form[`${componentName}IsMenu`] === true ? true : false,
        StartDate: state.form[`${componentName}CarouselStartDate`] || null,
        EndDate: state.form[`${componentName}CarouselEndDate`] || null
    };
};

export const selectStoreRulesForm = (state, componentName) => {
    let storeRoleContent = [];
    if (state.entity.storeRule && state.entity.storeRule.webStoreRulesContent) {
        state.entity.storeRule.webStoreRulesContent.map((item) => {
            let model = {
                Id: item.id,
                Content: state.form[`storeRulesContent_${item.id}`]
            }

            storeRoleContent.push(model);
        });
    }

    return {
        BranchId: state.common.branchId,
        Name: state.form[`${componentName}Name`] || '',
        Status: state.form[`${componentName}Status`] && state.form[`${componentName}Status`] === true ? "Active" : "Inactive",
        Content: storeRoleContent
    };
}

export const selectStoreRulesContentForm = (state, componentName) => {
    return {
        BranchId: state.common.branchId,
        Content: state.form[`${componentName}Content`] || ''
    };
}

export const selectWebUISettings = (state, compName) => {
    let keys = Object.keys(state.form);
    keys = keys.filter(k => k.includes(compName));
    let realKeys = keys.map(k => k = k.replace(compName, ''));
    let result = {};
    realKeys.map(rk => result[(rk[0].toUpperCase() + rk.slice(1))] = state.form[`${compName}${rk}`]);
    return result;
}

export const selectDeliveryZone = (state) => {
    return {
        BranchId: state.common.branchId,
        City: state.form.DeliveryZoneDeliveryCity,
        Cost: parseFloat(state.form.DeliveryZoneFixedDeliveryCost)
    }
}


export const selectUserRoleAccessModel = (state, name, userRoleId) => {
    const copyState = { ...state.form };

    let reportAccessList = [];
    let pageAccessList = [];

    for (let item in copyState) {
        if (item.indexOf(name + "Report-") !== -1) {
            let reportId = parseInt(item.split(`-`)[1]);
            reportAccessList.push({
                UserRoleId: userRoleId,
                ReportType: reportId,
                HasAccess: copyState[item],
                BranchId: state.common.branchId
            });
        }
        if (item.indexOf(name + "Page-") !== -1) {
            let pageId = parseInt(item.split(`-`)[1]);
            pageAccessList.push({
                UserRoleId: userRoleId,
                PageCode: pageId,
                HasAccess: copyState[item],
                BranchId: state.common.branchId
            });
        }
    }

    return { reportAccessList, pageAccessList };
};



export const isEmpty = (obj) => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export const selectSchedularModel = (state, name) => {
    return {
        Id: state.form[name + "Id"] ? parseInt(state.form[name + "Id"]) : 0,
        FileName: state.form[name + "FileName"],
        StartDate: state.form[name + "StartDate"],
        Value: state.form[name + "Value"],
        BranchId: state.common.branchId
    };
};

export const selectVerifyCredentialModel = (state, policy, name) => {
    return {
        Policy: policy,
        UserName: state.form[`${name}UserName`],
        Password: state.form[`${name}Password`],
        PinCode: state.form[`${name}PinCode`]
    }
}